import { Injectable, inject } from '@angular/core';
import { WarehouseProductApiService } from '../api/services/warehouse-product-api.service';
import { catchError, map, Observable, of } from 'rxjs';
import { SelectItem } from '@web/shared/ui';
import { CollectionRequestBuilder } from '@web/common';
import { WarehouseProductCollectionItemResponse } from '../api/responses/warehouse-product-collection-item.response';
import { Nillable } from '@web/utils';

@Injectable({
  providedIn: 'root',
})
export class WarehouseProductSelectItemsProviderService {
  private readonly warehouseProductApi = inject(WarehouseProductApiService);
  private readonly collectionRequestBuilder = inject(CollectionRequestBuilder);

  /* prettier-ignore */
  public fetchCollectionAsSelectItems<Key extends keyof WarehouseProductCollectionItemResponse>(key: Key, query: Nillable<string> = null): Observable<SelectItem<WarehouseProductCollectionItemResponse[Key]>[]> {
    return this.warehouseProductApi
      .fetchCollection({
        request: this.collectionRequestBuilder
          .query(query)
          .page(1)
          .pageSize(90)
          .sorts((builder) => [builder.ascendingFor('name').build()])
          .build(),
        options: { skipByLoading: true }
      })
      .pipe(
        map(({ items }) =>
          items.map((item) => {
            const label = `${item.sku} | (${item.quantity}) | ${item.name}`;

            return new SelectItem(label, item[key]);
          }),
        ),
        catchError(() => of([])),
      );
  }
}
